"use client"
import { Pagination, PaginationContent, PaginationEllipsis, PaginationItem, PaginationLink, PaginationNext, PaginationPrevious } from "@/components/ui/Pagination"
import { usePathname, useSearchParams } from "next/navigation";
import { useEffect, useState } from "react";
type Props = { total: number, url: string }
const PaginationView = ({ total, url }: Props) => {
    const [listPages, setListPages] = useState([]);
    useEffect(() => {
        let listPage: any = [];
        for (let index = 1; index <= total; index++) {
            listPage.push(index);
        }
        setListPages(listPage);
    }, [total]);

    const path = usePathname();
    const param = useSearchParams();
    //don`t touch this convert, this for seo !!! we have back link for this
    const page = param.get("page")
        ? Number(String(param.get("page")).replace("b", ""))
        : 1;
    if (!total || total == 1) return null;

    return (
        <Pagination>
            <PaginationContent>
                {page == 1 ? null : (
                    <PaginationItem>
                        <PaginationPrevious href={`${path}?page=${page == 1 ? page : page - 1}${url ? url : ""}`} />
                    </PaginationItem>

                )}
                {listPages?.map((i, index) => {
                    const number =
                        i === page ||
                        i + 1 === page ||
                        i + 2 === page ||
                        i - 1 === page ||
                        i - 2 === page;
                    if (number) {
                        return (
                            <PaginationItem key={index}>
                                <PaginationLink isActive={i == page} href={`${path}?page=${i}${url ? url : ""}`}>{i}</PaginationLink>
                            </PaginationItem>
                        );
                    } else {
                        return null;
                    }
                })}
                {listPages.length > 4 && listPages.length - 2 > page ? (
                    <>
                        <PaginationItem>
                            <PaginationEllipsis />
                        </PaginationItem>
                        <PaginationItem>
                            <PaginationLink href={`${path}?page=${listPages.length}${url ? url : ""}`}>{listPages.length}</PaginationLink>
                        </PaginationItem>
                    </>
                ) : null}
                {page == listPages.length ? null : (
                    <PaginationItem>
                        <PaginationNext href={`${path}?page=${page == listPages.length ? page : page + 1
                            }${url ? url : ""}`} />
                    </PaginationItem>
                )}
            </PaginationContent>
        </Pagination>
    )
}

export default PaginationView